import { GAMES } from "@/data/games";

const SINGLE = GAMES.filter((g) => g.type === "single");

export function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// Deterministic game-of-the-day shared by all users.
export function dailyGame() {
  const s = todayStr();
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return SINGLE[h % SINGLE.length];
}
